import PropTypes from "prop-types";
import AppState from "./AppState";

const APP_ACTIONS = {
  NAVIGATION_TOGGLE: "NAVIGATION_TOGGLE",
  NAVIGATION_MANUAL_CLOSE: "NAVIGATION_MANUAL_CLOSE",
};

function AppReducer(state, action) {
  console.log(action.type, action);
  switch (action.type) {
    case APP_ACTIONS.NAVIGATION_TOGGLE: {
      if(action.show){
        //opening
        localStorage.setItem("navigation-manual-closed", false);
        return {
          ...state,
          navigationOpen : true,
          navigationManualClosed : false
        };
      }else{
        //hiding
        if(action.close){
          //manual closing, not just hiding
          localStorage.setItem("navigation-manual-closed", true);
          return {
            ...state,
            navigationOpen : false,
            navigationManualClosed : true
          };
        }else{
          //just hiding
          return {
            ...state,
            navigationOpen : false
          };
        }
      }
    }
    case APP_ACTIONS.NAVIGATION_MANUAL_CLOSE: {
      console.log("state", state);
      return {
        ...state,
        navigationOpen : false,
        navigationManualClosed : true
      };
    }
    default:{
      console.log("DEFAULT CASE !!!");
      return state;
    }
  }
}
AppReducer.propTypes = {
  state: PropTypes.instanceOf(AppState).isRequired,
  action: PropTypes.string.isRequired
};

export { APP_ACTIONS, AppReducer };
